// GraphQL query to search products by a specific tag. Accepts a tag string and uses it in the Storefront search query
// We reuse the same fields as the text search to keep the shape identical.

import { LIGHT_PRODUCT_LIST_FIELDS } from './fragments/productFields';

const searchProductsByTagQuery = `
  query searchProductsByTag($query: String!, $first: Int = 20, $after: String, $country: CountryCode) @inContext(country: $country) {
    products(first: $first, after: $after, query: $query) {
      pageInfo { hasNextPage hasPreviousPage startCursor endCursor }
      edges {
        cursor
        node {
          ${LIGHT_PRODUCT_LIST_FIELDS({
              warningKey: 'productWarning',
              variantShape: 'edges',
              variantFirst: 20,
              imageCount: 50,
              includeCollections: true,
          })}
        }
      }
    }
  }
`;

export default searchProductsByTagQuery;
